import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const SHOP_AND_SERVICE_INDUSTRY_CONTENT_PATH = 'licenses.steps.businessInformation.forms.shopAndServiceIndustry';

export const shopAndServiceIndustrySchema = BasicBusinessInformationSchema.extend({
  startDate: z
    .string()
    .min(1, {
      message: `${SHOP_AND_SERVICE_INDUSTRY_CONTENT_PATH}.startDate.validation.required`,
    })
    // Basic ISO date format check (YYYY-MM-DD)
    .regex(/^\d{4}-\d{2}-\d{2}$/, {
      message: `${SHOP_AND_SERVICE_INDUSTRY_CONTENT_PATH}.startDate.validation.validFormat`,
    }),
  // Area in square meters (positive integer up to e.g. 99999)
  area: z
    .number({
      required_error: `${SHOP_AND_SERVICE_INDUSTRY_CONTENT_PATH}.venueSize.validation.required`,
    })
    .int({ message: `${SHOP_AND_SERVICE_INDUSTRY_CONTENT_PATH}.venueSize.validation.required` })
    .min(1, { message: `${SHOP_AND_SERVICE_INDUSTRY_CONTENT_PATH}.venueSize.validation.required` })
    .max(3000, { message: `${SHOP_AND_SERVICE_INDUSTRY_CONTENT_PATH}.venueSize.validation.max` }),
});

export const createShopAndServiceIndustryDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.ShopAndServiceIndustry,
  startDate: '',
});

export type ShopAndServiceIndustryForm = z.infer<typeof shopAndServiceIndustrySchema>;

export const toPayloadShopAndServiceIndustry = (
  form: ShopAndServiceIndustryForm,
  wareNumber: number,
): GeneralPayload => {
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(form.startDate).format('YYYY-MM-DD'),
    quantity: form.area ?? 0,
  };
};
